import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const DEFAULT_SIZE = 32

const IconWrapper = styled.span`
  display: inline-block;
`

/*   background: center/contain no-repeat url("${({ icon }) => icon}"); */

const Icon = ({ size = DEFAULT_SIZE, width = size, height = size, className, icon }) => (
  <IconWrapper
    className={className}
    style={{
      width,
      height,
      background: `center/contain no-repeat url("${icon}")`,
    }}
  />
)

Icon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.string.isRequired,
}

export default Icon
